const useScrollTop = () => {
    const pageScrollTop = () => {
        const dom = document.getElementById("tg-main-content");
        dom && dom.scrollTop > 0 && (dom.scrollTop = 0);
        document.body.scrollTop > 0 && (document.body.scrollTop = 0);
        document.documentElement.scrollTop > 0 &&
            (document.documentElement.scrollTop = 0);
    };

    return pageScrollTop;
};

export default useScrollTop;
